import styled from "styled-components";
import { pagePadding } from "_/style/layout";

export const Wrapper = styled.div`
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
  height: 100%;
  ${pagePadding};
`;
